
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleExclamation, faTriangleExclamation, faClock, faXmark, faLock, IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { t } from "i18next";

export type status = 'active' | 'inactive' | 'inactive-red' | 'block' | 'pending' | 'sent' | 'waiting-to-send' | 'not-sent' | 'locked';

type StatusRendererProps = {
    status: status;
    small?: boolean;
};

export const getStatusDetails = (status: status) => {
    const getStatus: Record<string, [IconDefinition, string, string]> = {
        'active': [faCheck, '#00C45E', t('datagrid:active')],
        'inactive': [faTriangleExclamation, '#FC9803', t('datagrid:inactive')],
        'inactive-red': [faXmark, '#FC2C03', t('datagrid:inactive')],
        'block': [faCircleExclamation, '#FC2C03', t('datagrid:block')],
        'pending': [faClock, '#CCAA00', t('datagrid:pending')],
        'sent': [faCheck, '#00C45E', t('datagrid:sent')],
        'waiting-to-send': [faClock, '#CCAA00', t('datagrid:waitingToSend')],
        'not-sent': [faXmark, '#FC2C03', t('datagrid:notSent')],
        'locked': [faLock, '#FC2C03', t('datagrid:inactive')]
    };

    let icon = faCheck;
    let color = '#00C45E';
    let text = t('datagrid:active');

    [icon, color, text] = getStatus[status];
    
    return {
        icon: icon,
        color: color,
        text: text
    };
}

export default function StatusRenderer({ status, small = false }: StatusRendererProps) {
    const { icon, color, text } = getStatusDetails(status);

    return (
        <div
            className={`${small ? 'min-w-[34px] max-w-[34px]' : 'max-w-[100px] min-w-[100px]'} group/label line-height-2 text-white rounded-full flex items-center justify-center gap-1`}
            style={{ padding: small ? '4px' : '2px 10px 2px 10px', lineHeight: '2', backgroundColor: color }}
            title={text}
        >
            <FontAwesomeIcon icon={icon} className={`text-lg m-1`} />
            {!small && (
                <p className="max-w-[55px] overflow-hidden truncate">
                    <span
                        className="absolute opacity-0 group-hover/label:opacity-100 rounded-full pr-3 py-0.5 -mt-0.5 pointer-events-none group-hover/label:pointer-events-auto"
                        style={{ backgroundColor: color }}
                    >
                        {text}
                    </span>
                    {text}
                </p>
            )}
        </div>
    );
}